import script from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorPage.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorPage.vue?vue&type=style&index=0&id=41ab1d3c&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41ab1d3c"]])

export default __exports__